export default __webpack_public_path__ + "static/media/YouGotPaid.b25a2062.png";